var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkyrocketLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1386,
    height: 38,
    viewBox: "0 0 1386 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.5C1.61929 16.5 0.5 17.6193 0.5 19C0.5 20.3807 1.61929 21.5 3 21.5V16.5ZM1384.77 20.7678C1385.74 19.7915 1385.74 18.2085 1384.77 17.2322L1368.86 1.32233C1367.88 0.34602 1366.3 0.34602 1365.32 1.32233C1364.35 2.29864 1364.35 3.88155 1365.32 4.85786L1379.46 19L1365.32 33.1421C1364.35 34.1184 1364.35 35.7014 1365.32 36.6777C1366.3 37.654 1367.88 37.654 1368.86 36.6777L1384.77 20.7678ZM3 21.5H1383V16.5H3V21.5Z",
    fill: "#1C3AD6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyrocketLine);
export default __webpack_public_path__ + "static/media/skyrocket-line.a603ef08.svg";
export { ForwardRef as ReactComponent };